import axios from "axios";

const API = axios.create({ baseURL: 'https://socialmedia22.herokuapp.com' });

// http://localhost:5000
// https://socialmedia22.herokuapp.com

API.interceptors.request.use(req => {
    if (localStorage.getItem("profile")) {
        req.headers.authorization = `Bearer ${JSON.parse(localStorage.getItem("profile")).token}`;
    }

    return req;
});

// users 

export const signUp = (dataForm) => API.post(`/users/signup`, dataForm);
export const signIn = (dataForm) => API.post(`/users/signin`, dataForm);
export const editUser = (id, updatedUser) => API.patch(`/users/${id}`, updatedUser);
export const delAccount = (id, oldPass) => API.patch(`users/del/${id}`, oldPass);

// posts

export const fetchPosts = () => API.get("/posts/");
export const newPost = (post) => API.post("/posts/", post);
export const deletePost = (id) => API.delete(`/posts/${id}`);
export const likePost = (id) => API.patch(`/posts/${id}/like`);
export const updatePost = (id, post) => API.patch(`/posts/${id}`, post);
export const newComment = (id, comment) => API.patch(`posts/${id}/newComment`, comment);
export const delComment = (id, commentId) => API.patch(`/posts/${id}/delComment`, commentId);

// rooms

export const fetchRooms = () => API.get("/rooms");

// serches

export const search = (user) => API.get(`/search?user=${user}`);
export const getSearchedUser = (id) => API.get(`/search/${id}`);
export const getSearchedPost = (id) => API.get(`/search/p/${id}`);